<template>
    <nav>
    <v-app-bar dark flat app dense class="cfbg">
      <v-toolbar-title >
        <img
          @click="gomain()"
          @keydown.enter="gomain()"
          class="logo"
          src="/edukanji-logo.png"
          alt="Edukanji - torna alla pagina principale"
          role="button"
          tabindex="0"
        >
      </v-toolbar-title>
      <slot></slot>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  methods:{
    gomain() {
      if (this.$route.path.indexOf("print")>-1) {
        const newPath = this.$route.path.replace("print","kanji");
        this.$router.push(newPath);
      }
    }
  }
}
</script>

<style scoped>
.logo {
  height:35px;
  margin-top:10px;
  cursor: pointer;
}

</style>